import type { FormValues, NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';

import { isPostalCodeRequired } from '../isPostalCodeRequired';
import { formatJapanesePostalCode } from '../japanesePostalCode';

export function normalizePostalCode({
	countryCode,
	postalCode,
}: Pick<FormValues, 'countryCode' | 'postalCode'>): NormalizedFormValues['postalCode'] {
	if (!isPostalCodeRequired({ countryCode }) || !postalCode) {
		return null;
	}

	// The field accepts either `ddd-dddd` or the bare `ddddddd` shape and applies no formatting
	// of its own (see usePostalCodeField). Insert the `ddd-dddd` hyphen here, on save, so the
	// persisted value is always consistently hyphenated regardless of how the supporter typed it.
	return countryCode === 'JP' ? formatJapanesePostalCode(postalCode) : postalCode;
}
